// extracted by mini-css-extract-plugin
export default {"wrapper":"TenantPopupTitle_wrapper__jLkYY","title":"TenantPopupTitle_title__Xpdjp","info_group":"TenantPopupTitle_info_group__GPQlK"};